import React, { useState, useEffect, useRef } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import CommonAlert from "../common/Commonalert";
import Sidebar from "../common/sidebar";
import ShowAlert from "../common/Showalert";
import { useTranslation } from "react-i18next";

const AddUser = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [adminName, setAdminName] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  const [admincPassword, setAdmincPassword] = useState("");
  const [showadminPassword, setShowAdminPassword] = useState(false);
  const [showadmincPassword, setShowAdmincPassword] = useState(false);
  const [adminRoles, setAdminRoles] = useState({});
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  const [errors, setErrors] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alerterrorPopup, setAlertErrorPopup] = useState(false);
  const [alerterrMessage, setAlerterrMessage] = useState([]);
  const [alertMessage, setAlertMessage] = useState([]);
  const [validationMessage, setValidationMessage] = useState("");
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [criteria, setCriteria] = useState({
    length: false,
    upperCase: false,
    lowerCase: false,
    number: false,
    specialChar: false,
  });
  const roleRef = useRef(null);

  const routeChange = () => {
    window.location.href = `/account`;
  };
  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_users")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    fetchroles();
    fetchUsers();
  }, []);

  const validatePassword = (password) => {
    const lengthCriteria = /.{8,}/;
    const upperCaseCriteria = /[A-Z]/;
    const lowerCaseCriteria = /[a-z]/;
    const numberCriteria = /[0-9]/;
    const specialCharacterCriteria = /[!@#$%^&*(),.?":{}|<>_\[\]-]/;
    setCriteria({
      length: lengthCriteria.test(password),
      upperCase: upperCaseCriteria.test(password),
      lowerCase: lowerCaseCriteria.test(password),
      number: numberCriteria.test(password),
      specialChar: specialCharacterCriteria.test(password),
    });
    let message = t("password_must_include_txt") + " ";
    let isValid = true;
    if (!lengthCriteria.test(password)) {
      message += `${t("password_criteria.length")}, `;
      isValid = false;
    }
    if (!upperCaseCriteria.test(password)) {
      message += `${t("password_criteria.upperCase")}, `;
      isValid = false;
    }
    if (!lowerCaseCriteria.test(password)) {
      message += `${t("password_criteria.lowerCase")}, `;
      isValid = false;
    }
    if (!numberCriteria.test(password)) {
      message += `${t("password_criteria.number")}, `;
      isValid = false;
    }
    if (!specialCharacterCriteria.test(password)) {
      message += `${t("password_criteria.specialChar")}, `;
      isValid = false;
    }
    if (isValid) {
      setValidationMessage(t("password_strong_txt"));
    } else {
      setValidationMessage(message.slice(0, -2) + ".");
    }
  };

  const handlePasswordFocus = () => {
    setPasswordFocused(true);
  };

  const handlePasswordBlur = () => {
    setPasswordFocused(false);
  };

  const fetchroles = async () => {
    setIsLoading(true);
    try {
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let URL = BaseUrl + `admin/getRoles`;
      const response = await http.get(URL);
      let responseData = response.data.data;
      if (response.data.success) {
        setRoles(responseData);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let URL = BaseUrl + `admin/all`;
      const response = await http.get(URL);
      let responseData = response.data.data;
      if (response.data.success) {
        setUsers(responseData);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const AddSubmit = (e) => {
    e.preventDefault();
    const isValid = formvalidation();
    if (isValid) {
      let payload = {
        adminName: adminName,
        adminEmail: adminEmail,
        adminPassword: adminPassword,
        adminRole: adminRoles,
      };
      const isFound = users.some((element) => {
        if (element.adminEmail === adminEmail) {
          return true;
        }
        return false;
      });
      if (isFound) {
        setAlertErrorPopup(true);
        setAlerterrMessage(t("user_already_exists_txt"));
      } else {
        var loginDetails = {};
        if (sessionStorage.getItem("authData")) {
          loginDetails = JSON.parse(sessionStorage.getItem("authData"));
        }
        let URL = BaseUrl + "admin/register/";
        http
          .post(URL, payload)
          .then(async (response) => {
            if (response.data.success === true) {
              setAlertPopup(true);
              setAlertMessage(t("user_added_successfully_txt"));
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  const formvalidation = () => {
    const errmsg = {};
    let isValid = true;
    if (!adminName.trim()) {
      errmsg.adminName = t("field_required_txt");
      isValid = false;
    }
    if (!adminEmail.trim()) {
      errmsg.adminEmail = t("field_required_txt");
      isValid = false;
    } else if (!validateEmail(adminEmail.trim())) {
      errmsg.adminEmail = t("invalid_email_txt");
      isValid = false;
    }
    if (!adminPassword.trim()) {
      errmsg.adminPassword = t("field_required_txt");
      isValid = false;
    } else if (!admincPassword.trim()) {
      errmsg.admincPassword = t("field_required_txt");
      isValid = false;
    } else if (adminPassword != admincPassword) {
      errmsg.admincPassword = t("password_not_match_txt");
      isValid = false;
    } else {
      validatePassword(adminPassword);
      if (validationMessage !== t("password_strong_txt")) {
        setPasswordFocused(true);
        isValid = false;
      }
    }
    if (typeof adminRoles !== "string" || !adminRoles.trim()) {
      errmsg.adminRoles = t("field_required_txt");
      isValid = false;
    }
    setErrors(errmsg);
    return isValid;
  };

  const validateEmail = (email) => {
    var emailRegex =
      /^[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/g;
    return emailRegex.test(email);
  };

  const handleValue = (e) => {
    const re = /^[a-zA-Z][a-zA-Z ]*$/;
    if (e.target.name === "adminName") {
      setAdminName(e.target.value);
    }
    if (e.target.name === "adminEmail") {
      setAdminEmail(e.target.value);
    }
    if (e.target.name === "adminPassword") {
      validatePassword(e.target.value.replace(/\s+/g, ""));
      setAdminPassword(e.target.value);
    }
    if (e.target.name === "admincPassword") {
      setAdmincPassword(e.target.value);
    }
    if (e.target.name === "adminRoles") {
      setAdminRoles(e.target.value);
    }
    const { name, value } = e.target;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  /*Added by K2b Sangeetha for View Password icon*/
  const togglePasswordVisibility = () => {
    setShowAdminPassword(!showadminPassword); // Toggle visibility for Confirm New Password
  };
  const toggleCnPasswordVisibility = () => {
    setShowAdmincPassword(!showadmincPassword); // Toggle visibility for Confirm New Password
  };
  /*Added by K2b Sangeetha for View Password icon*/

  return (
    <section className="dashboard-block">
      {alerterrorPopup && (
        <ShowAlert title={t("alert_txt")} message={alerterrMessage} />
      )}
      {alertPopup && (
        <CommonAlert title={t("alert_txt")} message={alertMessage} />
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <h1 className="checkout-title">{t("add_user_txt")}</h1>
            <div className="right-table-outer-wrap adm-add-users">
              <div className="form-field freeproduct-fieldset masterentry-fieldset form-container-xs">
                <form
                  className="form-field bottom addaccount"
                  onSubmit={(e) => AddSubmit(e)}
                >
                  <div className="input-field">
                    <span className="labeltxt">{t("name_txt")}</span>
                    <input
                      type="text"
                      name="adminName"
                      value={adminName}
                      onChange={handleValue}
                    />
                    {errors.adminName && (
                      <div className="error-msg">{errors.adminName}</div>
                    )}
                  </div>
                  <div className="input-field">
                    <span className="labeltxt">{t("email_address_txt")}</span>
                    <input
                      type="text"
                      name="adminEmail"
                      value={adminEmail}
                      onChange={handleValue}
                    />
                    {errors.adminEmail && (
                      <div className="error-msg">{errors.adminEmail}</div>
                    )}
                  </div>
                  <div className="input-field">
                    <span className="labeltxt">{t("password_txt")}</span>
                    <input
                      type={showadminPassword ? "text" : "password"}
                      name="adminPassword"
                      value={adminPassword}
                      onChange={handleValue}
                      onFocus={handlePasswordFocus}
                      onBlur={handlePasswordBlur}
                    />
                    <span
                      className="icon-eye"
                      onClick={togglePasswordVisibility}
                    >
                      <i
                        className={`fa ${showadminPassword ? "fa-eye-slash" : "fa-eye"}`}
                      ></i>
                    </span>
                    {errors.adminPassword && (
                      <div className="error-msg">{errors.adminPassword}</div>
                    )}
                    {passwordFocused && adminPassword && (
                      <div className="chg-pwd-lgd">
                        <ul className="chg-pwd-list">
                          <li
                            className={
                              criteria.length ? "checked" : "unchecked"
                            }
                          >
                            {t("password_criteria.length")}
                          </li>
                          <li
                            className={
                              criteria.upperCase ? "checked" : "unchecked"
                            }
                          >
                            {t("password_criteria.upperCase")}
                          </li>
                          <li
                            className={
                              criteria.lowerCase ? "checked" : "unchecked"
                            }
                          >
                            {t("password_criteria.lowerCase")}
                          </li>
                          <li
                            className={
                              criteria.number ? "checked" : "unchecked"
                            }
                          >
                            {t("password_criteria.number")}
                          </li>
                          <li
                            className={
                              criteria.specialChar ? "checked" : "unchecked"
                            }
                          >
                            {t("password_criteria.specialChar")}
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                  <div className="input-field">
                    <span className="labeltxt">
                      {t("confirm_password_txt")}
                    </span>
                    <input
                      type={showadmincPassword ? "text" : "password"}
                      name="admincPassword"
                      value={admincPassword}
                      onChange={handleValue}
                    />
                    <span
                      className="icon-eye"
                      onClick={toggleCnPasswordVisibility}
                    >
                      <i
                        className={`fa ${showadmincPassword ? "fa-eye-slash" : "fa-eye"}`}
                      ></i>
                    </span>
                    {errors.admincPassword && (
                      <div className="error-msg">{errors.admincPassword}</div>
                    )}
                  </div>
                  <div className="input-field">
                    <span className="labeltxt">{t("roles_txt")}</span>
                    <select
                      name="adminRoles"
                      onChange={handleValue}
                      ref={roleRef}
                    >
                      <option value="">{t("select_txt")}</option>
                      {roles.map((code) => (
                        <option key={code._id} value={code._id}>
                          {code.roleName}
                        </option>
                      ))}
                    </select>
                    {errors.adminRoles && (
                      <div className="error-msg">{errors.adminRoles}</div>
                    )}
                  </div>
                  <div className="btnfield">
                    <button title={t("add_user_txt")} type="submit" name="btnsubmit">
                      {t("add_user_txt")}
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button title={t("cancel_txt")} type="button" onClick={routeChange}>
                      {t("cancel_txt")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Footer />
        </section>
      </div>
    </section>
  );
};

export default AddUser;
